// extracted by mini-css-extract-plugin
export default {"dropIndicator":"drop-indicator-module__dropIndicator--_Ouja"};